import React from "react";
import { connect } from "react-redux";
import CodeWarsGroupList from "../../components/RoleBased/CodeWarsGroupList";
import { getCurrentUser } from "../../reducers/login";
import { fetchGroups, getGroups, getIsGroupLoading } from "../../reducers/group";
import { bindActionCreators } from "redux";


const CodeWarsGroupListContainer = (props) => {
  return <CodeWarsGroupList {...props} />
};

const mapState = (state, props) => ({
  currentUser: getCurrentUser(state),
  groups: getGroups(state),
  isLoading: getIsGroupLoading(state),
});

const actions = (dispatch, props) => ({
  fetchGroups: bindActionCreators(fetchGroups, dispatch),
});

export default connect(mapState, actions)(CodeWarsGroupListContainer);
